import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'

import { EmailContentResponse } from 'core'

import Modal from 'common/components/feedback/Modal'
import Button from 'common/components/general/Button'

import { formatDateTimeAMPM } from 'common/dateFormatters'

import './EmailContent.less'

interface EmailContentFormProps {
  visible: boolean
  onClose: (e: React.MouseEvent<HTMLElement>) => void
  content: EmailContentResponse
}

const EmailContentForm: React.FC<EmailContentFormProps> = ({ visible, onClose, content }) => {
  let { t: translate } = useTranslation()

  const formFooter = (
    <div>
      <Button className={'mr-8'} onClick={onClose}>
        {translate('general.close')}
      </Button>
    </div>
  )

  return (
    <Modal onCancel={onClose} visible={visible} title={content.subject} footer={formFooter} className="emailModal">
      <Row gutter={16}>
        <Col span={4}>
          <span className="emailContentTitle">{translate('csi-dashboard.email-search.email-content.sent')}:</span>
        </Col>
        <Col span={20}>{formatDateTimeAMPM(content.sendDate)}</Col>
      </Row>
      <Row gutter={16} className="mt-8">
        <Col span={4}>
          <span className="emailContentTitle">{translate('csi-dashboard.email-search.email-content.from')}:</span>
        </Col>
        <Col span={20}>{content.from}</Col>
      </Row>
      <Row gutter={16} className="mt-8">
        <Col span={4}>
          <span className="emailContentTitle">{translate('csi-dashboard.email-search.email-content.to')}:</span>
        </Col>
        <Col span={20}>{content.to}</Col>
      </Row>
      <Row gutter={16} className="mt-16">
        <Col span={24}>
          <div dangerouslySetInnerHTML={{ __html: content.htmlContent.replace('container', '') }}></div>
        </Col>
      </Row>
    </Modal>
  )
}

export default EmailContentForm
